import { createContext } from "react";

/**
 * Server-detected mobile flag (from User-Agent).
 * `undefined` means "not yet determined" (fallback to client-side detection).
 */
export const MobileContext = createContext<boolean | undefined>(undefined);
